interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  fullScreen?: boolean;
}

const sizeMap = {
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]',
};

export function LoadingSpinner({ size = 'md', message, fullScreen = false }: LoadingSpinnerProps) {
  const spinner = (
    <div className="flex flex-col items-center gap-4" role="status" aria-label={message || 'Loading'}>
      <div
        aria-hidden="true"
        className={[
          'rounded-full border-white/10 border-t-teal animate-spin',
          sizeMap[size],
        ].join(' ')}
      />
      {message && (
        <p className="text-chalk/70 text-sm font-display">{message}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
}

export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div className={['rounded-2xl bg-navy-light border border-white/8 overflow-hidden', className].join(' ')}>
      <div className="p-6 space-y-4">
        <div className="skeleton h-4 w-2/3 rounded-full" />
        <div className="skeleton h-4 w-full rounded-full" />
        <div className="skeleton h-4 w-3/4 rounded-full" />
      </div>
    </div>
  );
}
